import Pqp from "../3x1010/Pqp.js";
//import Sounder from "./Tools/sounder/Sounder";
import MainLoop from "./Tools/MainLoop";
import Spran from "./Tools/spran/Spran";
import Controls from "./Tools/controls/Controls";
import Game from "./Game.js";
import Assets from "./Tools/Assets.js";
import Main from "./Main.js";
import Sounder from "../3x1010/sounder/Sounder.js";


export default class ScreenIntro {
  constructor(skipFirstPage,callback) {
    this.callback = callback;
    this.cheat = 0;
    this.cheatBis = 0;
    this.skipFirstPage = skipFirstPage;
    Game.beginNearEnd = false;
    Game.invincible = false;

  }

  init() {
    this.mc = jQuery("#template-intro-screen").clone();
    this.mc.removeAttr("id");
    jQuery(".js-main").append(this.mc);
    //Sounder.play("smallloop", null, true);
    Main.that.sounder.playLoop("smallloop");
    if (Pqp.isMobile()) {
      jQuery(".js-mobile").show();
      jQuery(".js-desktop").hide();
    } else {
      jQuery(".js-mobile").hide();
      jQuery(".js-desktop").show();
    }
    this.initListeners();
    if (this.skipFirstPage) {
      this.chooseSong();
    } else {
      this.mc.on("click", this.chooseSong.bind(this));
    }
    if (Pqp.isMobile()) {
      jQuery(".do-tap", this.mc).show();
      jQuery(".do-click", this.mc).hide();
    } else {
      jQuery(".do-tap", this.mc).hide();
      jQuery(".do-click", this.mc).show();
    }

    this.checkTitle();


    let isMacBrowser = /Mac|iPod|iPhone|iPad/.test(navigator.platform);

    if (!isMacBrowser) {
      jQuery(".js-sardanap").hide();
    }
    if (Pqp.isIos()) {
      jQuery(".js-sardanap").show();
    }


  }

  checkTitle() {
    jQuery(window).on("resize.intro", this.onResize.bind(this));
    this.onResize();
  }

  onResize() {
    
    let title = jQuery(".js-title", this.mc);
    if (!title.is(":visible")){
      title = jQuery(".js-title-1", this.mc);
    }
    

    title.removeAttr("style");
    title.show();
    let y = title.position().top;
    let h = title.height();
    
    let ref = jQuery(".js-bottom", this.mc).position().top;
    if (!jQuery(".js-title", this.mc).is(":visible")){
      ref = jQuery(".js-bottom-1", this.mc).position().top;
    }

    while (y + h > ref) {
      if (Pqp.isMobile()) {
        h -= 16;
      } else {
        h -= 67;
      }
    }
    title.css("height", h);
  }


  initListeners() {
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    jQuery(window).on("blur", this.onMinimize.bind(this));
    jQuery(window).on("focus", this.onMaximize.bind(this));
  }

  onMinimize() {
    //Sounder.pauseAll();
    Main.that.sounder.pause("smallloop");
  }

  onMaximize() {
    Main.that.sounder.resume("smallloop");
    //Sounder.resumeAll();
  }


  destroy() {
    jQuery(window).off("resize.intro");
    jQuery(window).off("blur");
    jQuery(window).off("focus");
    //Sounder.stop("smallloop");
    Main.that.sounder.stop("smallloop");
    this.mc.remove();
  }


  dispatch(e) {
    if (this.callback) {
      this.callback.call(null, e);
    }
  }

  chooseSong() {
    if (Pqp.isMobile()) {
      if (!Pqp.isIos()) {
        let element = jQuery("body").get(0);
        element.requestFullscreen();
      }
    }


    this.mc.off("click");
    jQuery(".js-title", this.mc).hide();
    jQuery(".js-bottom", this.mc).hide();
    jQuery(".js-title-1", this.mc).show();
    jQuery(".js-bottom-1", this.mc).show();
    for (let x = 0; x < ScreenIntro.SONGS.length; x++) {
      let entry = jQuery("#template-theme").clone();
      entry.removeAttr("id");
      entry.on("click", this.preloadTheme.bind(this, ScreenIntro.SONGS[x]))
      jQuery(".js-author", entry).text(ScreenIntro.SONGS[x].author)
      jQuery(".js-name", entry).text(ScreenIntro.SONGS[x].desc)
      jQuery(".js-len", entry).text(ScreenIntro.SONGS[x].length)
      let tmp = Main.getThemeOnSavegame(ScreenIntro.SONGS[x].id);
      if (tmp.won > 0) {
        jQuery(".js-won", entry).text(tmp.distance + "%");
        jQuery(".js-won", entry).addClass("green");
      } else if (tmp.played > 0) {
        jQuery(".js-won", entry).text(tmp.distance+"%");
        jQuery(".js-won", entry).addClass("red");
      } else {
        jQuery(".js-won", entry).text("0%");
      }

      jQuery(".js-themes", this.mc).append(entry);
    }

    jQuery(".js-title-1", this.mc).on("click", this.checkCheat.bind(this));
    this.onResize();


  }

  checkCheat() {
    this.cheat++;
    if (this.cheat === 3) {
      Game.invincible = true;
      jQuery(".js-cheat", this.mc).show();
      jQuery(".js-cheat", this.mc).on("click", this.checkCheatBis.bind(this));
    }

  }

  checkCheatBis() {
    this.cheatBis++;
    if (this.cheatBis === 3) {
      Game.beginNearEnd = true;
      jQuery(".js-cheat", this.mc).text("*SUPER CHEAT ON*");
    }

  }


  preloadTheme(o) {
    if (Pqp.isMobile()) {
      if (!Pqp.isIos()) {
        let element = jQuery("body").get(0);
        element.requestFullscreen();
      }
    }
    jQuery(".js-cheat", this.mc).hide();
    jQuery(".js-settings").hide();
    jQuery(".js-title-1", this.mc).hide();
    jQuery(".js-bottom-1", this.mc).hide();
    jQuery(".js-preload-song", this.mc).show();
    Assets.load(o, this.preStartGame.bind(this, o));


  }


  preStartGame(o, e) {
    if (e.type === Assets.EVENT_ALL_LOADED) {
      Main.that.sounder.callback = this.startGame.bind(this,o)
      Main.that.sounder.add(o.id, o.src);
    }
  }

  startGame(o, e) {
    if (e.type == Sounder.ALL_SOUNDS_READY) {
      setTimeout(this.doStartGame.bind(this, o), 1500);
    }
  }

  doStartGame(o) {
    jQuery(".js-settings").show();
    this.dispatch({ type: ScreenIntro.EVENT_ENDED, data: o })
  }


}

ScreenIntro.EVENT_ENDED = "eventEnded";
ScreenIntro.SONGS = [
  { id: "theme0", src: "assets/sounds/themes/theme_pal.mp3", length: "3.16", author: "PAUL NORMAN", desc: "CLASSIC THEME (PAL)" },
  { id: "theme1", src: "assets/sounds/themes/theme_ntsc.mp3", length: "3.16", author: "PAUL NORMAN", desc: "CLASSIC THEME (NTSC)" },
  { id: "theme2", src: "assets/sounds/themes/remakes/A0d of the Subversive Elements - Aztec challenge (run Cornholio run!).mp3", length: "2.46", author: "A0D OF THE SUBVERSIVE ELEMENTS", desc: "AZTEC CHALLENGE (RUN CORNHOLIO RUN!)" },
  { id: "theme3", src: "assets/sounds/themes/remakes/Lello Caliendo - Aztec challenge Evolution.mp3", length: "3.13", author: "LELLO CALIENDO", desc: "AZTEC CHALLENGE EVOLUTION" },
  { id: "theme4", src: "assets/sounds/themes/remakes/Aztec Challenge (Run Of Despair - 2020 edition).mp3", length: "3.49", author: "ANDREA BARONI", desc: "AZTEC CHALLENGE (RUN OF DESPAIR 2020 EDITION)" },
  { id: "theme5", src: "assets/sounds/themes/remakes/chosc - Aztec Challenge - Mental Trance Remix.mp3", length: "4.20", author: "CHOSC", desc: "AZTEC CHALLENGE - MENTAL TRANCE REMIX" },
  { id: "theme6", src: "assets/sounds/themes/remakes/Andi Diat - Aztec Challenge Rocks.mp3", length: "4.35", author: "ANDI DIAT", desc: "AZTEC CHALLENGE ROCKS" },
  { id: "theme7", src: "assets/sounds/themes/remakes/load error - Aztec Challenge (Quetzal Goa Remix).mp3", length: "6.47", author: "LOAD_ERROR", desc: "AZTEC CHALLENGE (QUETZAL GOA REMIX)" },
  { id: "theme8", src: "assets/sounds/themes/remakes/Dr Future - Aztec Challenge (A Runners Game).mp3", length: "3.59", author: "DR FUTURE", desc: "AZTEC CHALLENGE (A RUNNERS GAME)" },
  { id: "theme9", src: "assets/sounds/themes/remakes/ICEtr00per - Aztec Challenge (Remix).mp3", length: "5.35", author: "ICEXUICK", desc: "AZTEC CHALLENGE (REMIX)" },
  { id: "theme10", src: "assets/sounds/themes/remakes/ScareCrow - Headbangers Challenge.mp3", length: "2.27", author: "SCARECROW", desc: "HEADBANGERS CHALLENGE" },
  { id: "theme11", src: "assets/sounds/themes/remakes/LPChip - Aztec Challenge (Hell on Earth mix).mp3", length: "2.44", author: "LPCHIP", desc: "AZTEC CHALLENGE (HELL ON EARTH MIX)" },
  { id: "theme12", src: "assets/sounds/themes/remakes/Sidicium - Aztec Challenge (Aztec Funeral mix).mp3", length: "4.51", author: "SIDICIUM", desc: "AZTEC CHALLENGE (AZTEC FUNERAL MIX)" },
  { id: "theme14", src: "assets/sounds/themes/remakes/chosc - Aztec Challenge (maja remix).mp3", length: "2.17", author: "CHOSC", desc: "AZTEC CHALLENGE (MAJA REMIX)" },
  { id: "theme15", src: "assets/sounds/themes/remakes/Press Play On Tape - Aztec Challenge.mp3", length: "2.57", author: "PRESS PLAY ON TAPE", desc: "AZTEC CHALLENGE" },
  { id: "theme16", src: "assets/sounds/themes/remakes/Davide Gatti - Aztec Challenge Evolution.mp3", length: "6.08", author: "DAVIDE GATTI", desc: "AZTEC CHALLENGE EVOLUTION" },
  { id: "theme17", src: "assets/sounds/themes/remakes/Tony Vera - Aztec Challenge.mp3", length: "2.31", author: "TONY VERA", desc: "AZTEC CHALLENGE" },
  { id: "theme13", src: "assets/sounds/themes/remakes/Frank F. and Himself - Aztec Challenge Tribe - Sacrifice is ready.mp3", length: "3.18", author: "FRANK F.", desc: "AZTEC CHALLENGE TRIBE - SACRIFICE IS READY" },
]
